import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import cx from 'classnames'

import {
  Grid,
  ListItemIcon,
  ListItemText,
  Divider,
  ListItem,
  Avatar,
  makeStyles
} from '@material-ui/core'
import IconAnyProduct from '@material-ui/icons/FormatListBulleted'

import useViewportSize from '~/components/useViewportSize'
import { useLiterals } from '~/components/Literals'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    zIndex: 300,
    position: 'relative',
    border: '1px solid #707070',

    [theme.breakpoints.up('md')]: {
      top: 0,
      width: 390,
      margin: 8,
      zIndex: 1100
    }
  },
  line1: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    height: 64
  },
  absolute: { position: 'absolute', top: 32, background: '#FFF' }
}))

function HeaderSearchWrapper({ config, children }) {
  const classes = useStyles()
  const view = useSelector((state) => state.app.view)
  const viewport = useViewportSize()

  const { getLiteral } = useLiterals()
  const { hideProductsList, anyProducts, isDistributor, showContextViewStore } = config
  const showAnyProduct =
    view === 'VIEW_EMPTY' && (hideProductsList || isDistributor) && anyProducts !== 'off'

  const isMobile = viewport.width < 930

  return (
    <Grid
      className={cx(classes.wrapper, {
        [classes.absolute]: view === 'VIEW_EMPTY' && !isMobile
      })}
    >
      <Grid className={showContextViewStore ? '' : classes.line1}>{children}</Grid>

      {showAnyProduct && (
        <Grid style={{ textAlign: 'left' }}>
          <Divider />
          <ListItem component={Link} to="/produto/todos" button>
            <ListItemIcon>
              <Avatar className={cx(classes.avatar, 'bg')}>
                <IconAnyProduct />
              </Avatar>
            </ListItemIcon>
            <ListItemText className={classes.text} primary={getLiteral('1996')} />
          </ListItem>
        </Grid>
      )}
    </Grid>
  )
}

export default HeaderSearchWrapper
